import React, { useState, useEffect } from "react";
import Content from "../../../components/Content";
import { ActivityDetailsTabs } from "../../../constants/ActivityConstants";
import { ActivityOverviewView } from "./ActivityOverviewView";

export const ActivityDetailsView = () => {
  const [lastTab, setLastTab] = useState(1);

  useEffect(() => {
    let lastTab = JSON.parse(localStorage.getItem("lastTab"));
    if (lastTab) {
      setLastTab(lastTab);
    }
  }, []);
  return (
    <>
      <Content
        tabs={true}
        tabList={ActivityDetailsTabs}
        lastTab={lastTab}
        title={"Aktivitet"}
      >
        <div value={1}>
          <ActivityOverviewView />
        </div>
        <div value={2}></div>
      </Content>
    </>
  );
};
